import AnimatedRouter from 'react-animated-router';
import { Navigate, Route } from 'react-router-dom';
import Card from 'components/Card';
import IBDisabledEntry from 'components/IBDisabledEntry';
import TabNav from 'components/TabNav';
import security from 'stores/security';
import { printf } from 'utils/i18n';
import Statements from './Statements';
import Tax from './Tax';
import Trade from './Trade';
import './style.scss';

export default function Reports() {
    if (!security.isMarscoAccount) {
        return (
            <Card page>
                <IBDisabledEntry
                    desc={
                        <span
                            dangerouslySetInnerHTML={{
                                __html: printf(
                                    __(
                                        '请前往Interactive Brokers盈透证券的Client Portal下载您的账户报表和税务文件。 如果您没有登录权限，请点击<a href="%s">此处</a>获取您的 IB 登录用户名和密码。 若您有任何其他问题，请通过在线聊天联系我们或发送电子邮件至 %s。'
                                    ),
                                    '/profile/security/link',
                                    `<a href="mailto:support@tradeup.com">support@tradeup.com</a>`
                                )
                            }}
                        />
                    }
                />
            </Card>
        );
    }

    const navs = [
        {
            name: __('Statements'),
            path: 'statement'
        },
        {
            name: __('Trade Confirms'),
            path: 'trade'
        },
        {
            name: __('Tax Document'),
            path: 'tax'
        }
    ];

    return (
        <Card page className="reports-root">
            <Card form>
                <TabNav navs={navs} mode="lite" />
                <div className="pt-2">
                    <AnimatedRouter className="reports-container">
                        <Route index element={<Navigate to="statement" replace />} />
                        <Route path="statement" element={<Statements />} />
                        <Route path="trade" element={<Trade />} />
                        <Route path="tax" element={<Tax />} />
                        <Route path="*" element={<Navigate to=".." replace />} />
                    </AnimatedRouter>
                </div>
            </Card>
        </Card>
    );
}
